import { render, staticRenderFns } from "./CategoriesOpportunity.vue?vue&type=template&id=294df684&scoped=true&"
import script from "./CategoriesOpportunity.vue?vue&type=script&lang=js&"
export * from "./CategoriesOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesOpportunity.vue?vue&type=style&index=0&id=294df684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294df684",
  null
  
)

export default component.exports